export const FEEDS_SET_FIELD_MAP = 'FEEDS_SET_FIELD_MAP';
export const FEEDS_REMOVE_FIELD_MAP = 'FEEDS_REMOVE_FIELD_MAP';
export const FEEDS_ADD_FIELD_MAP = 'FEEDS_ADD_FIELD_MAP';
export const FEEDS_INIT_FIELD_MAP = 'FEEDS_INIT_FIELD_MAP';
export const FEEDS_HYDRATE = 'FEEDS_HYDRATE';

export const feedsSetFieldMap = action => ({
    type: FEEDS_SET_FIELD_MAP,
    ...action,
});

export const feedsRemoveFieldMap = action => ({
    type: FEEDS_REMOVE_FIELD_MAP,
    ...action,
});

export const feedsAddFieldMap = sobjectName => ({
    type: FEEDS_ADD_FIELD_MAP,
    sobjectName
});

export const feedsInitFieldMap = sobjectName => ({
    type: FEEDS_INIT_FIELD_MAP,
    sobjectName
});

export const feedsHydrate = feeds => ({
    type: FEEDS_HYDRATE,
    ...feeds
});
